import React, { useState, useEffect, useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import apiClient from '../../../api'; 
import { Card, CardTitle } from '../styles';
import { FaChartBar, FaCog } from 'react-icons/fa';
import { Button } from '../../../components/common/Button';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// MUDANÇA 1: Adicionei 'onDataLoaded' nas props
const KeywordsAnalysis = ({ user, filtros, onManageClick, onDataLoaded }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!user?.cliente_id) return;
      setLoading(true);
      try {
        // Converte os filtros para Query String
        const params = new URLSearchParams();
        if (filtros.pagina && filtros.pagina !== 'todas') params.append('page_id', filtros.pagina);
        if (filtros.post && filtros.post !== 'todos') params.append('post_id', filtros.post);
        if (filtros.tipo && filtros.tipo !== 'todos') params.append('media_type', filtros.tipo);
        if (filtros.viewInicio) params.append('start_date', filtros.viewInicio);
        if (filtros.viewFim) params.append('end_date', filtros.viewFim);

        const res = await apiClient.get(`/api/analytics/keywords/${user.cliente_id}?${params.toString()}`);
        
        const keywordsData = res.data;
        setData(keywordsData);

        // MUDANÇA 2: Envia os dados para o componente Pai (para o Export funcionar)
        if (onDataLoaded) {
            onDataLoaded(keywordsData);
        }

      } catch (error) {
        console.error("Erro analytics keywords:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user, filtros, onDataLoaded]); // Adicionei onDataLoaded nas dependências

  // Configuração do Gráfico
  const chartData = useMemo(() => {
    return {
      labels: data.map(d => d.keyword),
      datasets: [
        {
          label: 'Menções nos Comentários',
          data: data.map(d => d.count),
          backgroundColor: 'rgba(54, 162, 235, 0.6)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1,
          borderRadius: 4,
          barThickness: 20,
        },
      ],
    };
  }, [data]);

  const options = {
    indexAxis: 'y', // Barra Horizontal
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw} menções neste período`
        }
      }
    },
    scales: {
      x: { beginAtZero: true, grid: { display: false } },
      y: { grid: { display: false } }
    },
    onClick: (event, elements) => {
        if(elements.length > 0) {
            const index = elements[0].index;
            const keyword = data[index].keyword;
            console.log("Filtrar por:", keyword); 
        }
    }
  };

  return (
    <Card style={{ height: '100%', minHeight: '350px', display: 'flex', flexDirection: 'column' }}>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem'}}>
        <div>
            <CardTitle style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <FaChartBar /> Análise de Tópicos
            </CardTitle>
            <p style={{fontSize: '0.8rem', color: '#666', margin: '0.25rem 0 0 0'}}>
                Frequência das suas palavras-chave monitoradas.
            </p>
        </div>
        <Button variant="secondary" onClick={onManageClick} style={{fontSize: '0.8rem', padding: '0.4rem 0.8rem'}}>
            <FaCog /> Gerenciar
        </Button>
      </div>

      <div style={{ flex: 1, position: 'relative' }}>
        {loading ? (
            <p style={{textAlign: 'center', color: '#999', marginTop: '2rem'}}>Calculando...</p>
        ) : data.length > 0 ? (
            <Bar data={chartData} options={options} />
        ) : (
            <div style={{textAlign: 'center', color: '#999', marginTop: '2rem'}}>
                <p>Nenhuma das suas palavras-chave foi encontrada nos filtros atuais.</p>
                <small>Tente aumentar o período ou adicionar termos mais comuns.</small>
            </div>
        )}
      </div>
    </Card>
  );
};

export default KeywordsAnalysis;